import { MODES } from 'darwin_core/utils/consts.js';

// Shared vocabulary for the "in an override" state, used by both the zone screen's
// cancel-override exit and the mode control (which locks its toggles while an
// override is active). Keeping it in one place means the two surfaces can never
// drift on which modes count as an override or on what the cancel affordance says.

// Whether a zone is in an override the user can cancel — a scheduled override
// (OverrideNext), a boost (OverridePlus), or a backend-driven grid-saving (DSR)
// period. In all three the plain mode toggles lock, so a cancel exit must exist.
// DSR is treated as an override for HEATING only, matching the app: its
// HotWaterModeSelect scopes the hot-water override to OverrideNext/OverridePlus
// and never checks DSRActive.
export function isOverridden(mode, isDhw = false) {
  if (mode === MODES.OverrideNext || mode === MODES.OverridePlusHours) {
    return true;
  }
  return !isDhw && mode === MODES.DSRActive;
}

// Copy for the active override. The cancel wording is the app's
// (CancelOverrideActionPanel / CancelOverrideHeader): "Cancel Override" for every
// user override — a scheduled override or a Plus Hours / Boost hold, on heating and
// hot water alike — and "Cancel DSR Program" for a grid program. The label is the
// hint shown beside locked mode toggles; it still names the hold per family
// ("Boost" is reserved for hot-water zones, a heating zone's hold is "Plus Hours").
export function overrideCopy(mode, isDhw = false) {
  if (mode === MODES.DSRActive) {
    return { label: 'In a DSR program', cancel: 'Cancel DSR Program' };
  }
  if (mode === MODES.OverridePlusHours) {
    return {
      label: isDhw ? 'Boosting' : 'In Plus Hours',
      cancel: 'Cancel Override',
    };
  }
  return { label: 'In a temporary override', cancel: 'Cancel Override' };
}
